<div class="fixed inset-0 z-[10000] flex items-center justify-center bg-[#101219]/80 px-4 backdrop-blur-sm">
  <div class="relative w-full max-w-[360px] overflow-hidden rounded-[28px] border border-[#2F7FFE]/50 bg-[#24262F] px-6 pb-6 pt-7 text-center shadow-[0_24px_80px_rgba(0,0,0,0.45)]">
    <div class="pointer-events-none absolute inset-x-0 top-0 h-[140px] bg-[radial-gradient(circle_at_top,_rgba(47,127,254,0.35),_transparent_70%)]"></div>

    @if (!popup().blocking) {
      <button
        type="button"
        class="absolute right-4 top-4 z-[1] flex h-9 w-9 items-center justify-center rounded-full bg-white/8 text-white/65 transition-colors hover:bg-white/12 hover:text-white"
        (click)="onDismiss()"
        aria-label="Закрыть">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      </button>
    }

    <div class="relative z-[1]">
      <div class="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#2F7FFE]/16 ring-1 ring-[#2F7FFE]/35">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 9V14.25M14 18.375H14.0105M24.5 14C24.5 19.799 19.799 24.5 14 24.5C8.20101 24.5 3.5 19.799 3.5 14C3.5 8.20101 8.20101 3.5 14 3.5C19.799 3.5 24.5 8.20101 24.5 14Z" stroke="#8FC7FF" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <h2 class="mb-3 text-[28px] font-semibold leading-[1.05] text-white">
        {{ popup().title }}
      </h2>

      <p class="mx-auto mb-4 max-w-[288px] text-sm leading-5 text-white/78">
        {{ popup().message }}
      </p>

      @if (retryHint()) {
        <p class="mb-6 text-xs leading-4 text-white/45">
          {{ retryHint() }}
        </p>
      } @else {
        <div class="mb-6"></div>
      }

      <button
        type="button"
        class="mx-auto flex h-13 w-full items-center justify-center rounded-[24px] bg-[#2F7FFE] px-6 text-base font-medium text-white transition-opacity disabled:cursor-default disabled:opacity-60"
        [disabled]="retrying()"
        (click)="onRetry()">
        {{ retrying() ? 'Проверяем...' : 'Повторить' }}
      </button>
    </div>
  </div>
</div>
